import { SHELL_BRIDGE_VERSION } from "./envelope.js";
import { SHELL_MESSAGE_TYPES } from "./messages.js";
const KNOWN = new Set(SHELL_MESSAGE_TYPES);
export function encode(msg) {
    return JSON.stringify(msg);
}
/**
 * Parses a frame. Never throws: malformed JSON, a non-object, a wrong/missing `v`
 * or an unrecognised `type` all yield `{ type: 'unknown', raw }` so both sides can ignore them.
 */
export function decode(json) {
    let raw;
    try {
        raw = JSON.parse(json);
    }
    catch {
        return { type: "unknown", raw: json };
    }
    if (typeof raw !== "object" || raw === null)
        return { type: "unknown", raw };
    const o = raw;
    if (o["v"] !== SHELL_BRIDGE_VERSION)
        return { type: "unknown", raw };
    if (typeof o["type"] !== "string" || !KNOWN.has(o["type"]))
        return { type: "unknown", raw };
    if (typeof o["payload"] !== "object" || o["payload"] === null)
        return { type: "unknown", raw };
    return raw;
}
//# sourceMappingURL=codec.js.map